// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hUHd","colBig":"styles_colBig__H0y3C","colSmall":"styles_colSmall__18dXr"};